import { getLang, LANGS, loadLang, pickLang, setLang, SOURCE_LANG, t as $t } from '@enercad/core';

/* Interface language: remembered per browser, first guess from the browser's languages. */

const KEY = 'enercad.lang';

function stored(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

/** Loads and applies the saved (or browser) language; call before the first render. */
export async function initLang(): Promise<void> {
  // a browser in a language we do not offer gets English; Turkish only when the browser asks for it
  const code = stored() ?? pickLang(navigator.languages ?? [navigator.language], 'en');
  await applyLang(code);
}

export async function applyLang(code: string): Promise<void> {
  try {
    await loadLang(code);
  } catch {
    code = SOURCE_LANG; // translation file could not be loaded (offline)
  }
  setLang(code);
  const info = LANGS.find((l) => l.code === getLang())!;
  document.documentElement.lang = info.code;
  document.documentElement.dir = info.rtl ? 'rtl' : 'ltr';
  document.title = $t('EnerCAD · Elektrik proje çizim yazılımı');
}

/** Chooses a language, remembers it and redraws through `redraw`. */
export async function chooseLang(code: string, redraw: () => void): Promise<void> {
  try {
    localStorage.setItem(KEY, code);
  } catch {
    /* private mode: only for this page */
  }
  await applyLang(code);
  redraw();
}

/** Language drop-down; a document-level listener (main.ts) reacts to it. */
export function langPicker(): string {
  const cur = getLang();
  return `<select class="lang" data-lang aria-label="Language / Dil">${LANGS.map((l) => `<option value="${l.code}"${l.code === cur ? ' selected' : ''}>${l.name}</option>`).join('')}</select>`;
}
